import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-no-items-found',
  templateUrl: './no-items-found.component.html'
})
export class NoItemsFoundComponent {
  @Input() text = 'Нема податоци.';
}
